export const RP_AVERAGE_GAS_MODEL_LIST = 'RP_AVERAGE_GAS_MODEL_LIST'
export const RP_AVERAGE_GAS_SEARCH = 'RP_AVERAGE_GAS_SEARCH'
export const RP_AVERAGE_GAS_PAGINATION = 'RP_AVERAGE_GAS_PAGINATION'
export const RP_AVERAGE_GAS_DROP_DOWN_SEARCH_YEAR = 'RP_AVERAGE_GAS_DROP_DOWN_SEARCH_YEAR'
